import { Component, OnInit, ViewChild } from '@angular/core';
import { BasePage } from 'src/app/core/basepages/allbasepages';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { DataService } from 'src/app/services/data.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProposalService } from 'src/app/services/proposal.service';
import { FormService } from 'src/app/services/form';
import { Constants } from 'src/app/core/constants';
import { Router, ActivatedRoute } from '@angular/router';
import { AppSettings } from 'src/app/app.settings';
import { TeslaAutocompleteComponent } from '@tesla/angular2-tesla-common/autocomplete/autocomplete.component';
import { AppGlobalDataService } from 'src/app/services/appglobaldata.service';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'app-/landingpage',
  templateUrl: './landingpage.component.html',
  styleUrls: ['./landingpage.component.scss']
})
export class landingpageComponent extends BasePage implements OnInit {
  appSettings: AppSettings;
  loginAsForm: FormGroup;
  showSupplierSelection = false;
  searchSupplierURL: string ;
  @ViewChild('SupplierAutoComplete') SupplierAutoComplete: TeslaAutocompleteComponent;
  changeSupplierMode = false;
  public formErrors = {
    SupplierCode: '',
};
  constructor(
    private appGlobalDataService: AppGlobalDataService,
    localstorageService: LocalstorageService,
    private dataService: DataService,
    private fb: FormBuilder,
    private proposalService: ProposalService,
    public FormService: FormService,
    logger: NGXLogger,
    appSettings: AppSettings,
    private readonly route: ActivatedRoute,
    private readonly router: Router
    ) {
    super(localstorageService, logger, appSettings);
    this.loginAsForm  = this.fb.group({
      LoginAsId: 1,
      SupplierCode: [
        null,
        Validators.compose([
            Validators.required])]
  });
  this.appSettings = appSettings;
  this.searchSupplierURL = this.appSettings.Packaging2APIUrl + '/externaldata/supplier/all';

}

  ngOnInit() {
    this.route.queryParamMap.subscribe(params => {
      const changeParam = params.get('change');
      if (changeParam) {
        this.loginAsForm.controls['LoginAsId'].patchValue(2);
        this.showSupplierSelection = true;
        this.changeSupplierMode = false;
      }
  });
    if (this.IsEmployee) {
      // this.initializeLocalStorageFields();
    } else {
      this.router.navigate(['/home']);
    }
  }

  LoginAsChanged(event: any) {
    const loginAsSelected = this.loginAsForm.get('LoginAsId').value;
    this.showSupplierSelection = (loginAsSelected === 2); // login as supplier radio button
    }

ContinueClicked() {
  this.initializeLocalStorageFields();
  const loginAsSelected = this.loginAsForm.get('LoginAsId').value;
  this.ValidateForm();
  if (this.loginAsForm.valid) {

if (loginAsSelected === 2) {  // ogin as supplier radio button
  // refresh menu
  const supplierCodeToLoginAs = this.loginAsForm.get('SupplierCode').value;
  this.localstorageService.store(this.locStorage.IsLoggedInAsSupplier, Constants.IsLoggedAsSupplierSecurityKey);
  this.localstorageService.store(this.locStorage.CurrentSupplierCode, supplierCodeToLoginAs);
  this.setFlags();
}
this.appGlobalDataService.RefreshloginAsSource('supplier');
this.router.navigate(['/home']);
  }
// redirect to home in any case

}

getshowSupplierSelection() {
  return this.showSupplierSelection;
}

onEmptySupplierCode(eventObj: any): void {
  this.SupplierAutoComplete.list = [];
}
ValidateForm() {
  const loginAsSelected = this.loginAsForm.get('LoginAsId').value;
  if (loginAsSelected === 2) {
  this.formErrors = this.FormService.validateForm(
    this.loginAsForm,
    this.formErrors);
  } else {
    this.loginAsForm.controls['SupplierCode'].setErrors(null);
      return true;
  }
}

initializeLocalStorageFields() {
  this.localstorageService.store(this.locStorage.IsLoggedInAsSupplier, '');
  this.localstorageService.store(this.locStorage.CurrentSupplierCode, '');
}


}
